import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=6adc3153&scoped=true&"
import script from "./UploadAvatar.vue?vue&type=script&lang=js&"
export * from "./UploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=6adc3153&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc3153",
  null
  
)

export default component.exports